import * as React from "react";

function HelpLogo(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="38.76" height="38.76" viewBox="0 0 38.76 38.76" {...props}>
      <g id="Group_1544" data-name="Group 1544" transform="translate(-1500.342 -11.395)">
        <rect
          id="Rectangle_412"
          data-name="Rectangle 412"
          width="37.76"
          height="37.76"
          rx="13.285"
          transform="translate(1500.842 11.895)"
          fill="#fff"
          stroke="#4e536c"
          stroke-width="1"
        />
        <path
          id="Shape"
          d="M10.5-24a10.431,10.431,0,0,0-7.425,3.075A10.432,10.432,0,0,0,0-13.5,10.431,10.431,0,0,0,3.075-6.075,10.431,10.431,0,0,0,10.5-3a10.432,10.432,0,0,0,7.425-3.075A10.431,10.431,0,0,0,21-13.5a10.432,10.432,0,0,0-3.075-7.425A10.432,10.432,0,0,0,10.5-24Zm0,19.524a8.973,8.973,0,0,1-3.511-.707A9.042,9.042,0,0,1,4.12-7.118,8.982,8.982,0,0,1,2.186-9.987a8.956,8.956,0,0,1-.71-3.513,8.981,8.981,0,0,1,.707-3.511A9.06,9.06,0,0,1,4.118-19.88a8.982,8.982,0,0,1,2.869-1.934,8.956,8.956,0,0,1,3.513-.71,8.967,8.967,0,0,1,3.511.708,9.043,9.043,0,0,1,2.869,1.933,8.989,8.989,0,0,1,1.934,2.87,8.956,8.956,0,0,1,.71,3.513,8.96,8.96,0,0,1-.708,3.511A8.974,8.974,0,0,1,16.88-7.12a8.982,8.982,0,0,1-2.869,1.934A8.941,8.941,0,0,1,10.5-4.477Zm0-15.188h-.009a3.653,3.653,0,0,0-2.6,1.08,3.66,3.66,0,0,0-1.074,2.6.739.739,0,0,0,.738.739.74.74,0,0,0,.739-.739,2.207,2.207,0,0,1,2.2-2.2,2.311,2.311,0,0,1,1.67.71,1.9,1.9,0,0,1,.541,1.417c-.022.444-.043.863-1.368,2.188A4.746,4.746,0,0,0,9.657-11.2a.74.74,0,0,0,.662.808c.027,0,.052,0,.074,0a.735.735,0,0,0,.734-.666c.047-.486.514-1.041,1.251-1.778,1.454-1.454,1.747-2.2,1.8-3.154a3.366,3.366,0,0,0-.946-2.512A3.787,3.787,0,0,0,10.5-19.664Zm-.13,10.551a.891.891,0,0,0-.444.119.89.89,0,0,0-.444.769.889.889,0,0,0,.888.888.889.889,0,0,0,.888-.888.89.89,0,0,0-.444-.769A.891.891,0,0,0,10.367-9.113Z"
          transform="translate(1509 44)"
          fill="#3c4252"
        />
      </g>
    </svg>
  );
}

export default HelpLogo;
